// // src/routes/PrivateRoute.js
// import React from "react";
// import { Navigate } from "react-router-dom";
// import PropTypes from "prop-types";

// const PrivateRoute = ({ children }) => {
//   const token = localStorage.getItem("authToken"); // MUST match saved key
//   return token ? children : <Navigate to="/sign-in" replace />;
// };

// PrivateRoute.propTypes = {
//   children: PropTypes.node.isRequired,
// };

// export default PrivateRoute;
// src/routes/PrivateRoute.js
import React from "react";
import { Navigate } from "react-router-dom";
import PropTypes from "prop-types";

const PrivateRoute = ({ children }) => {
  const token = localStorage.getItem("authToken");
  const expiry = localStorage.getItem("authTokenExpiry");

  // Token expired
  if (!token || !expiry || new Date().getTime() > parseInt(expiry)) {
    localStorage.removeItem("authToken");
    localStorage.removeItem("authTokenExpiry");
    localStorage.removeItem("user"); // optional: if you store user info
    return <Navigate to="/sign-in" replace />;
  }

  return children;
};

PrivateRoute.propTypes = {
  children: PropTypes.node.isRequired,
};

export default PrivateRoute;
